/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportConnectionTagsElysDefinition$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The Badgeur Uid.
 */
  badgeurUid: string;

/**
 * The Elys connection Uid.
 */
  elysUid: string;

/**
 * Indicates if the imports can create tags or only updates them.
 */
  allowCreate?: boolean;
      body?: Blob
}

export function importConnectionTagsElysDefinition(http: HttpClient, rootUrl: string, params: ImportConnectionTagsElysDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, importConnectionTagsElysDefinition.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('badgeurUid', params.badgeurUid, {});
    rb.path('elysUid', params.elysUid, {});
    rb.query('allowCreate', params.allowCreate, {});
    rb.body(params.body, 'application/vnd.ms-excel');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

importConnectionTagsElysDefinition.PATH = '/custom/stations/{uid}/badgeur/{badgeurUid}/elys/configuration/{elysUid}/import';
